import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import spacing from 'styles/spacing';

const useStyles = makeStyles({
  root: {
    margin: '24px 0',
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'space-between',
    '& .MuiInputBase-root': {
      height: '40px',
    },
  },
  bloco: {
    display: 'flex',
    minWidth: '500px',
    '& > * + *': {
      marginLeft: `${spacing.xxxsmall}`,
    },
  },
  row: {
    display: 'flex',
  },
  col: {
    flex: 1,
  },
  inputList: {
    '& .MuiIconButton-root': {
      color: colors.black,
    },
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& > * + *': {
      marginLeft: `${spacing.xxsmall}`,
    },
  },
});

export default useStyles;
